import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles'
import {
  Input,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import * as DeviceActionCreators from '../../../actions/device'
import CommandParamsDialog from './CommandParamsDialog'

const setRelayCommand = {
  command: 'set_relay',
  params: {
    relay: { type: 'int' },
    state: { type: 'bool' },
    duration: { type: 'int' },
  },
}

class HydraIO extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    isEditing: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  static mapDispatchToProps(dispatch) {
    return {
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
    }
  }

  static styles = () => ({
    root: {
      width: 'auto',
    },
  })

  state = {
    volumePerPulse: null,
    executingCommand: null,
  }

  onVolumePerPulseChange = (ev) => {
    this.state.volumePerPulse = ev.currentTarget.value
    const val = parseFloat(this.state.volumePerPulse)

    const target = this.props.device.target_config
    const config = {
      ...target,
      water_meter: {
        ...target.water_meter,
        volume_per_pulse: Number.isNaN(val) ? undefined : val,
      },
    }

    this.props.onChange(config)
  }

  onRestart = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'restart')
  }

  onIdent = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'ident')
  }

  activateWaterRelay = (val) => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'set_relay', {
      relay: { type: 'int', value: val },
      state: { type: 'bool', value: true },
      duration: { type: 'int', value: 10 },
    })
  }

  onWaterOn = () => {
    this.activateWaterRelay(0)
  }

  onWaterOff = () => {
    this.activateWaterRelay(1)
  }

  onShowCommandDialog = (command) => {
    this.setState({ executingCommand: command })
  }

  onCloseCommandDialog = () => {
    this.setState({ executingCommand: null })
  }

  onCommand = (command) => {
    this.props.deviceActions.executeCommand(this.props.device.id, command.command, command.params)
  }

  render() {
    const { classes, device, isEditing } = this.props
    const { volumePerPulse, executingCommand } = this.state

    const current = device.current_config
    const target = device.target_config

    return (
      <>
        <Table className={classes.root}>
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Current</TableCell>
              <TableCell>Target</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Water Meter: liters per pulse</TableCell>
              <TableCell>{current.water_meter.volume_per_pulse}</TableCell>
              <TableCell>
                <Input
                  disabled={!isEditing}
                  value={volumePerPulse || target.water_meter.volume_per_pulse}
                  onChange={this.onVolumePerPulseChange}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Button onClick={this.onRestart}>Restart</Button>
        <Button onClick={this.onIdent}>Identify</Button>
        <Button onClick={this.onWaterOn}>Water On</Button>
        <Button onClick={this.onWaterOff}>Water Off</Button>
        <Button onClick={() => this.onShowCommandDialog(setRelayCommand)}>
          Set Relay
        </Button>
        { executingCommand
          && (
            <CommandParamsDialog
              command={executingCommand}
              onExecute={this.onCommand}
              onClose={this.onCloseCommandDialog}
            />
          )}
      </>
    )
  }
}

export default connect(
  HydraIO.mapStateToProps,
  HydraIO.mapDispatchToProps,
)(withStyles(HydraIO.styles)(HydraIO))
